<template>
  <el-dialog
    :title="title"
    :visible.sync="showDialog"
    :width="dialogWidth"
    class="chargeDialog"
    :lock-scroll="true"
    @open="openDialog"
    @close="closeDialog"
  >
    <div class="grid" v-if="transactionInfo">
      <money
        v-if="!hasGoods"
        v-model="amount"
        v-bind="money"
        class="u-16 el-input__inner text-center"
      ></money>

      <div v-if="hasGoods" class="u-16 grid">
        <el-form
          :model="chargeForm"
          ref="chargeForm"
          label-width="70px"
          label-position="left"
          class="u-16 grid chargeForm"
        >
          <el-form-item
            class="u-8"
            prop="email"
            label="Email"
            :rules="[
              {
                required: true,
                message: 'Пожалуйста введите email',
                trigger: 'blur'
              },
              {
                type: 'email',
                message: 'введите корректный email',
                trigger: 'blur'
              }
            ]"
          >
            <el-input type="text" v-model="chargeForm.email"></el-input>
          </el-form-item>

          <table class="chargetable u-16">
            <thead>
              <tr valign="middle">
                <th>
                  <el-checkbox
                    :indeterminate="isIndeterminate"
                    v-model="checkAll"
                    @change="handleCheckAllChange"
                  ></el-checkbox>
                </th>
                <th>Наименование</th>
                <th>Ставка</th>
                <th>Предмет расчета</th>
                <th>Способ расчета</th>
                <th width="150" align="right">Сумма</th>
                <th></th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="(item, index) in chargeForm.goodsList" :key="index">
                <!-- checkbox -->
                <td>
                  <el-form-item label-width="0">
                    <el-checkbox
                      v-model="item.selected"
                      :value="item.id"
                      @change="handleCheckedGoodsChange($event, item)"
                    />
                  </el-form-item>
                </td>

                <!-- name -->
                <td width="30%">
                  <el-form-item label-width="0">
                    <el-input
                      type="textarea"
                      :autosize="{ minRows: 1, maxRows: 3 }"
                      v-model="item.name"
                      :ref="'goodsName' + index"
                    ></el-input>
                  </el-form-item>
                </td>

                <!-- tax -->
                <td>
                  <el-form-item label-width="0">
                    <el-select
                      v-model="item.tax"
                      value-key="id"
                      placeholder="Ставка"
                    >
                      <el-option
                        v-for="el in goods.tax"
                        :key="el.id"
                        :label="el.value"
                        :value="el.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </td>
                <!-- subject -->
                <td>
                  <el-form-item label-width="0">
                    <el-select
                      v-model="item.payment_subject_type"
                      value-key="id"
                      placeholder="Предмет расчета"
                    >
                      <el-option
                        v-for="el in goods.subjectTypes"
                        :key="el.id"
                        :label="el.value"
                        :value="el.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </td>

                <!-- method -->
                <td>
                  <el-form-item label-width="0">
                    <el-select
                      v-model="item.payment_method_type"
                      value-key="id"
                      placeholder="Способ расчета"
                    >
                      <el-option
                        v-for="el in goods.paymentMethod"
                        :key="el.id"
                        :label="el.value"
                        :value="el.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </td>

                <!-- amount -->
                <td width="150">
                  <el-form-item label-width="0">
                    <div class="el-input el-input--small">
                      <money
                        class="el-input__inner text-center"
                        v-bind="money"
                        v-model="item.amount"
                        @input="handleInputAmount"
                      ></money>
                    </div>
                  </el-form-item>
                </td>

                <!-- remove -->
                <td>
                  <el-button
                    @click.prevent="removeGoods(item)"
                    icon="el-icon-delete"
                    type="text"
                  ></el-button>
                </td>
              </tr>
            </tbody>
          </table>
        </el-form>
        <div class="u-16 grid between ver-margin-10">
          <el-button @click="addGoods">Добавить позицию</el-button>
          <div class="hor-padding-10">
            <strong
              >Сумма к списанию: {{ (amount * 100) | amountFormat }}
              {{ currencyCharacter(this.transactionInfo.currency) }}
            </strong>
          </div>
        </div>
      </div>
    </div>
    <span slot="footer" class="grid start">
      <el-button @click="$emit('closeChargeDialog')">Отмена</el-button>
      <el-button type="primary" @click="Charge(amount)" :loading="loading"
        >Подтвердить</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import Vuex from "vuex";
import { mapGetters } from "vuex";
import axios from "axios";
import { apiUrl } from "@/api/apiUrl";
import errors from "@/localize/errors.js";
import goods from "@/localize/goods.js";
import { Money } from "v-money";
import { _ } from "vue-underscore";

export default {
  name: "chargeDialog",
  props: ["showDialogCharge", "transactionInfo"],
  data() {
    return {
      loading: false,
      title: "Списать",
      amountCharge: 0,
      showControls: false,
      chargeForm: {
        email: "",
        goodsList: []
      },
      goods: goods,
      selectedRows: [],
      isIndeterminate: false,
      checkAll: false,
      money: {
        decimal: ".",
        thousands: " ",
        prefix: "",
        suffix: "",
        precision: 2,
        masked: false
      },
      showError: false,
      errorMessage: "Не выбрана ни одна позиция в товарах"
    };
  },
  filters: {
    taxName(id) {
      if (id) return goods.tax.find(el => el.id == id).value;
    },
    subjectName(id) {
      if (id) return goods.subjectTypes.find(el => el.id == id).value;
    },
    methodName(id) {
      if (id) return goods.paymentMethod.find(el => el.id == id).value;
    }
  },
  computed: {
    ...mapGetters(["currencyCharacter"]),
    amount: {
      get() {
        if (!this.hasGoods) {
          return this.amountCharge / 100;
        } else {
          let a = 0;
          this.chargeForm.goodsList.forEach(el => {
            if (el.selected) a = parseFloat(a + el.amount);
          });
          return a;
        }
      },
      set(value) {
        if (!this.hasGoods) this.amountCharge = value * 100;
      }
    },
    hasGoods() {
      if (this.transactionInfo.goods)
        return this.transactionInfo.goods.length > 0;
      else return false;
    },
    chargeGoods() {
      return this.chargeForm.goodsList.filter(el => el.selected);
    },
    dialogWidth() {
      return this.hasGoods ? "1000px" : "300px";
    },
    showDialog: {
      get() {
        return this.showDialogCharge;
      },
      set(v) {
        return v;
      }
    }
  },
  methods: {
    Charge(amount) {
      var params = {
        transaction_id: this.transactionInfo.id,
        amount: Math.round(this.amount * 100),
        operation: "charge"
      };
      if (this.hasGoods) {
        let goods = "";
        this.chargeGoods.forEach(el => {
          goods =
            goods +
            el.name +
            "=" +
            Math.round(el.amount * 100) +
            "," +
            el.payment_subject_type +
            "," +
            el.tax +
            "," +
            el.payment_method_type +
            ";";
        });
        goods = goods.substring(0, goods.length - 1);
        _.extend(params, {
          Params: "Email=" + this.chargeForm.email,
          Goods: goods
        });
      }
      var config = {
        headers: {
          "Authorization-Token": localStorage.getItem("Authorization-Token")
        }
      };
      this.loading = true;
      axios
        .post(apiUrl + "transaction/operate", params, config)
        .then(({ data }) => {
          if (data.state_id == 0) {
            this.$message({
              message: "Списание успешно выполнено",
              type: "success",
              duration: 500
            });

            setTimeout(() => {
              this.$emit("loadAsyncData", this.transactionInfo.id);
              this.$emit("closeChargeDialog");
            }, 500);
          } else {
            this.$message.error(
              "(" + data.state_id + ") " + errors[data.error_code]
            );
          }
          this.loading = false;
        })
        .catch(err => {
          this.$message.error(errors[err.response.data.error_code]);
          this.loading = false;
        });
    },
    handleInputAmount(value) {
      this.showError = false;
    },
    handleCheckAllChange(val) {
      this.showError = false;
      this.isIndeterminate = false;
      this.chargeForm.goodsList.forEach(el => {
        el.selected = val;
      });
    },
    handleCheckedGoodsChange(e, item) {
      this.showError = false;
      let checkedCount;
      checkedCount = this.chargeForm.goodsList.filter(el => el.selected == true)
        .length;
      this.checkAll = checkedCount === this.chargeForm.goodsList.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.chargeForm.goodsList.length;
    },
    focusName() {
      const last = this.chargeForm.goodsList.length - 1;
      this.$refs["goodsName" + last][0].focus();
    },
    addGoods() {
      this.chargeForm.goodsList.push({
        id: null,
        name: "",
        amount: 0,
        currency_code: 643,
        tax: this.terminalTax,
        selected: true,
        payment_subject_type: 1,
        payment_method_type: 4
      });
      this.showError = false;
      this.$nextTick(() => {
        this.focusName();
      });
    },
    removeGoods(item) {
      var index = this.chargeForm.goodsList.indexOf(item);
      if (index !== -1) {
        this.chargeForm.goodsList.splice(index, 1);
      }
    },
    openDialog() {
      this.checkAll = true;
      this.amountCharge = this.transactionInfo.amount;
      this.money.suffix =
        " " + this.currencyCharacter(this.transactionInfo.currency);

      let emailParam = this.transactionInfo.cp.find(el => el.k == "Email");
      this.chargeForm.email = emailParam ? emailParam.v : "";

      const arr = this.transactionInfo.goods.map(a => ({ ...a }));
      arr.forEach(el => {
        el.amount = parseFloat(el.amount / 100);
        el.selected = true;
        this.amount += el.amount;
      });
      this.chargeForm.goodsList = [...arr];

      document.documentElement.style.overflow = "hidden";
    },
    closeDialog() {
      this.$emit("closeChargeDialog");
      this.amountCharge = 0;
      this.chargeForm.email = "";
      this.chargeForm.goodsList = [];
      this.loading = false;
      document.documentElement.style.overflow = "auto";
    },
    getScrollbarWidth() {
      return window.innerWidth - document.documentElement.clientWidth;
    }
  },
  components: {
    Money
  }
};
</script>

<style lang="sass">
.chargeDialog .el-dialog
  margin-top: 30px !important
  .el-dialog__header
    border-bottom: 1px solid #eee
  .el-dialog__title
    font-weight: bold
    font-size: 16px
.break-word
  word-break: break-word
  line-height: 1.2
.chargeForm
  .el-form-item
    margin-bottom: 0px
  .el-form-item__error
    position: relative
.chargetable
  margin-top: 5px
  th
    font-size: 12px
    padding: 10px .5em
    background-color: #F6F9FC
    border-width: 1px 0 1px
    vertical-align: middle
    border-color: #F3F3F3
    text-transform: uppercase
    font-weight: 400 !important
  td
    padding: 0.5em
    vertical-align: middle
    border: 1px solid #E7EBF1
    border-width: 0 0 1px
  label
    margin-bottom: 0px
.chargeResult
  .el-dialog__body
    padding-top: 10px
</style>
